import { Component, OnInit, Input, NgModule } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-singel-document-viewer',
  templateUrl: './singel-document-viewer.component.html',
  styleUrls: ['./singel-document-viewer.component.css']
})
export class SingelDocumentViewerComponent implements OnInit {

  imgeBase64: any;
  @Input()
  get base64() {
    return this.imgeBase64;
  }
  set base64(val: string) {
    if (val) {
      if (val.length > 150) {
        this.imgeBase64 = this.sanitizer.bypassSecurityTrustResourceUrl(`data: image/${this.imageType};base64, ${val}`);
      } else {
        this.imgeBase64 = this.sanitizer.bypassSecurityTrustResourceUrl(`${val}`);
      }
    } else {
      this.imgeBase64 = this.sanitizer.bypassSecurityTrustResourceUrl('');
    }
  }

  imgSourcePath: any;

  @Input() savePlaceType: number;
  @Input() get sourcePath() {
    return this.imgeBase64;
  }
  set sourcePath(val) {
    if (val) {
      this.imgSourcePath = val;
      if (this.savePlaceType == 1 || this.savePlaceType == 4) {
        this.imgeBase64 = this.sanitizer.bypassSecurityTrustResourceUrl(val);
      }
      else {
        this.imgeBase64 = this.sanitizer.bypassSecurityTrustResourceUrl(`data: image/${this.imageType};base64, ${val}`);
      }
    } else {
      this.imgeBase64 = this.sanitizer.bypassSecurityTrustResourceUrl('');
    }
  }

  @Input() class: string;
  @Input() imageClass: string;
  @Input() imageType = 'png';
  @Input() alt = '';

  @Input() width = 500;
  @Input() height = 450;
  @Input() styleType = 'px';
  @Input() isOrigin = false;
  @Input() isClickable = false;
  @Input() isPathSource = false;
  constructor(private sanitizer: DomSanitizer) { }

  ngOnInit() {
  }

  imageClicked() {
    if (this.isClickable) {
      this.isOrigin = !this.isOrigin;
    }
  }
}

/////////  patient  list module
@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forChild()
  ],
  declarations: [
    SingelDocumentViewerComponent
  ],
  exports: [
    SingelDocumentViewerComponent
  ]
})
export class SingelDocumentViewerModule { }
